import { IResolvers } from '@workbench-stack/core';

export const notificationResolver: (services: any) => IResolvers = (services: any) => ({
    Notification: {
        severity: (parent) => parent.severity,
        message: (parent) => parent.message,
        actions: (parent) => parent.actions,
        sticky: (parent) => parent.sticky,
    },
    Query: {
        showNotification: (_, args, context) => {
            console.log('SHOW NOTIFICATION Query----', services());
            // switch (args.notification.type) {
            //     case 'error':
            //         StaticServices.notificationService.get().error(args.notification.message);
            //         return true;
            //     case 'notify':
            //         StaticServices.notificationService.get().notify(args.notification.message as any);
            //         return true;
            //     case 'warn':
            //         StaticServices.notificationService.get().warn(args.notification.message);
            //         return true;
            //     default:
            //         StaticServices.notificationService.get().info(args.notification.message);
            //         return true;
            // }
            return true;
        },
    },
    Mutation: {
        addNotification: (_, args, context) => {
            services().notificationService.addNotification(args.notification);
            return true;
        },
        closeNotification: (_, args, context) => {
            services().notificationService.closeNotification(args.index);
            return true;
        },
        handler: (_, args, context) => {
            if (!args.arg) {
                alert('Handle action');
                return true;
            }
            switch (args.arg.type) {
                case 'query':
                    context.client.query({
                        query: args.arg.document,
                        variables: args.arg.variables,
                    });
                    return true;
                case 'mutation':
                    context.client.mutate({
                        mutation: args.arg.document,
                        variables: args.arg.variables,
                    });
                    return true;
                default:
                    alert('Handle onclick Button action');
                    return true;
            }
        },
    },
});
